module.exports = __webpack_public_path__ + "img/suit (3).17be0fea.png";